import React, { useEffect, useState } from "react";
import { getAuth, onAuthStateChanged } from "firebase/auth";
import "./carLists.scss";
import AdminInfo from "../common/adminInfo";
import * as helper from "../../helper/helper";
import * as service from "./carServices";
import { ToastContainer, toast } from "react-toastify";
import Spinner from "../common/spinner";
import MotorbikeLatestStatus from "../motorbike/components/motorbikeLatestStatus";
import HiddenByUser from "../motorbike/components/hiddenByUser";

function CarSingle(props) {
  const state = props.history.location.state
    ? props.history.location.state
    : null;
  const [isLoading, setLoading] = useState(true);
  const [list, setLists] = useState();

  useEffect(() => {
    const auth = getAuth();
    onAuthStateChanged(auth, (user) => {
      if (!user) {
        return props.history.replace("/login");
      }
    });

    if (state === null) {
      return props.history.replace("/");
    }

    getCarById();
  }, []);

  const renderSpinner = () => {
    if (isLoading) {
      return <Spinner />;
    }
  };

  const getCarById = async () => {
    setLoading(true);
    try {
      const result = await service.adminGetCarInfo(state.car.car_uid);
      setLoading(false);
      if (result) {
        switch (result.data.code) {
          case 200:
            setLists(result.data.car);
            return;
          case 401:
            toast.error(result.data.message);
            return this.props.history.replace("/login");
          case 500:
            return toast.error(result.data.message);
          default:
            return toast.error(result.data.message);
        }
      }
    } catch (error) {
      toast.error(error.message);
    }
    setLoading(false);
  };

  return (
    <div className="car">
      <ToastContainer />
      {renderSpinner()}
      {list && list.car_latest_status !== "Processing" ? (
        <div className="container">
          <div className="row">
            <div className="headline">
              <h3>{"Car " + list.make + " " + list.model}</h3>
            </div>
          </div>
          <AdminInfo
            header="Registration State"
            value={list.registration_state}
          />
          <AdminInfo
            header="Registration Number"
            value={list.registration_number}
          />
          <AdminInfo header="Car Type" value={list.car_type} />
          <AdminInfo header="Engine Size" value={list.engine_size} />

          <AdminInfo
            header="Insurance Policy Validity Date"
            value={list.ipc_validity_date}
          />
          <AdminInfo
            header="Registration Expiry Date"
            value={list.rego_validity_date}
          />
          <AdminInfo
            header="Insurance Company"
            value={list.ipc_insurer_company}
          />
          <AdminInfo header="Policy Number" value={list.ipc_policy_number} />
          <AdminInfo
            header="Date Visibility Update"
            value={helper.timestampToDateYearNanoSecond(
              list.date_visibility_updated._seconds,
              list.date_visibility_updated._nanoseconds
            )}
          />
          <HiddenByUser
            header="Hidden By User"
            value={list.is_hidden_by_user}
            id={list.car_uid}
            props={props}
            handleReloadSingle={() => getCarById()}
            isCar={true}
          />
          <MotorbikeLatestStatus
            vehicle={list}
            isCar={true}
            props={props}
            handleReloadSingle={() => getCarById()}
          />
          {list.car_latest_status_note !== "" ? (
            <AdminInfo
              header="Car Latest Status Note"
              value={list.car_latest_status_note}
            />
          ) : null}

          <div className="row">
            <div className="group-btn">
              <ul>
                <li>
                  <button
                    onClick={() =>
                      props.history.push(
                        "/home/findMotorbike/motorbikeList/motorbike/rider",
                        { riderId: list.owner_uid }
                      )
                    }
                  >
                    View Rider
                  </button>
                </li>
              </ul>
            </div>
          </div>
        </div>
      ) : (
        <>
          {list ? (
            <MotorbikeLatestStatus
              vehicle={list}
              isCar={true}
              props={props}
              handleReloadSingle={() => getCarById()}
            />
          ) : null}

          {list && list.car_latest_status_note !== "" ? (
            <AdminInfo
              header="Car Latest Status Note"
              value={list.car_latest_status_note}
            />
          ) : null}
        </>
      )}
    </div>
  );
}

export default CarSingle;
